import React from 'react';
import { motion } from 'framer-motion';
export function FirstVisitSteps() {
  const steps = [{
    num: '1',
    title: 'Quick Consultation',
    desc: 'Tell the team what you are hoping to improve and what has or has not helped so far.'
  }, {
    num: '2',
    title: 'Focused Evaluation',
    desc: 'Paragon Chiropractic reviews your movement, symptoms, history, and goals to determine whether laser therapy is appropriate.'
  }, {
    num: '3',
    title: 'Laser Therapy Plan',
    desc: 'If laser therapy is a fit, the team will explain recommended session frequency, expected timeline, and whether other services should be combined for better support.'
  }];
  return <section className="py-20 md:py-24 bg-brand-gray-light" data-id="element-113">
      <div className="w-full max-w-6xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-114">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.6
      }} className="text-center max-w-3xl mx-auto mb-14" data-id="element-115">
          <h2 className="text-3xl md:text-4xl lg:text-5xl font-black text-brand-navy mb-5 leading-tight" data-id="element-116">
            What to Expect at Your First Visit
          </h2>
          <p className="text-base md:text-lg text-gray-700 leading-relaxed mb-3" data-id="element-117">
            We make the process simple, transparent, and focused on your
            specific needs.
          </p>
          <p className="text-sm md:text-base text-brand-teal-dark font-semibold italic" data-id="element-118">
            The first step is not committing to treatment. The first step is
            finding out whether laser therapy makes sense for your situation.
          </p>
        </motion.div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-6 relative" data-id="element-119">
          <div className="hidden md:block absolute top-10 left-[16%] right-[16%] h-0.5 bg-brand-teal/30 z-0" data-id="element-120" />

          {steps.map((step, idx) => <motion.div key={idx} initial={{
          opacity: 0,
          y: 30
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.5,
          delay: idx * 0.15
        }} className="bg-white rounded-2xl p-7 md:p-8 shadow-md border border-gray-200 relative z-10 text-center" data-id="element-121">
              <div className="w-14 h-14 mx-auto bg-brand-teal text-white rounded-full flex items-center justify-center mb-5 shadow-lg shadow-brand-teal/30 ring-4 ring-brand-gray-light font-black text-xl" data-id="element-122">
                {step.num}
              </div>
              <h3 className="text-xl font-black text-brand-navy mb-3 leading-tight" data-id="element-123">
                {step.title}
              </h3>
              <p className="text-gray-700 leading-relaxed text-sm md:text-base" data-id="element-124">
                {step.desc}
              </p>
            </motion.div>)}
        </div>
      </div>
    </section>;
}